// src/components/home/SchoolsSection/SchoolsSection.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheck,
    faArrowRight,
    faStar
} from '@fortawesome/free-solid-svg-icons';
import LEKudluLogo from '../../../assets/images/LEKudluLogoTSP.svg';
import './SchoolsSection.css';

const SchoolsSection = () => {
    const features = [
        'Ages 18 months to 5+ years',
        'Play-based learning approach',
        'Creative arts & STEM activities',
        'Experienced educators',
        'Daycare with flexible hours',
        'Safe, nurturing environment'
    ];

    return (
        <section className="schools" id="schools">
            <div className="schools__container">
                {/* Header */}
                <div className="schools__header">
                    <span className="schools__label">Our School</span>
                    <h2 className="schools__title">
                        Little Elly
                        <span className="schools__title-accent">Kudlu</span>
                    </h2>
                </div>

                {/* Main Card */}
                <div className="schools__card">
                    <div className="schools__card-glow"></div>

                    {/* Left - Logo & Description */}
                    <div className="schools__info">
                        <img
                            src={LEKudluLogo}
                            alt="Little Elly Kudlu Logo"
                            className="schools__logo"
                        />
                        <span className="schools__franchise">A Little Elly Franchise</span>
                        <p className="schools__description">
                            Our Kudlu preschool offers a nurturing space where young
                            learners thrive through play-based and structured programs
                            designed for holistic development.
                        </p>
                        <Link to="/schools/little-elly-kudlu" className="schools__cta">
                            <span>Learn More</span>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </Link>
                    </div>

                    {/* Right - Features */}
                    <div className="schools__features">
                        <h3 className="schools__features-title">What We Offer</h3>
                        <ul className="schools__features-list">
                            {features.map((feature, index) => (
                                <li key={index} className="schools__feature">
                                    <span className="schools__feature-icon">
                                        <FontAwesomeIcon icon={faCheck} />
                                    </span>
                                    <span>{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Coming Soon */}
                <div className="schools__future">
                    <FontAwesomeIcon icon={faStar} className="schools__future-icon" />
                    <div className="schools__future-content">
                        <h3>More Programs Coming Soon</h3>
                        <p>We're expanding our educational offerings with innovative programs for holistic child development.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SchoolsSection;
